import React, { useState, useRef } from 'react';
import { UploadIcon, XIcon, FileTextIcon } from 'lucide-react';
interface DocumentUploadProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  onFileChange: (file: File | null) => void;
  currentFile: File | null;
}
const DocumentUpload: React.FC<DocumentUploadProps> = ({
  title,
  description,
  icon,
  onFileChange,
  currentFile
}) => {
  const [preview, setPreview] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    if (file) {
      onFileChange(file);
      // Create a preview for image files
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = () => {
          setPreview(reader.result as string);
        };
        reader.readAsDataURL(file);
      } else {
        setPreview(null);
      }
    }
  };
  const handleRemoveFile = () => {
    onFileChange(null);
    setPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  const formatFileSize = (bytes: number): string => {
    if (bytes < 1024) return bytes + ' bytes';else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';else return (bytes / 1048576).toFixed(1) + ' MB';
  };
  return <div className="border border-gray-200 rounded-lg" data-id="element-220">
      {!currentFile ? <div className="p-4 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50" onClick={() => fileInputRef.current?.click()} data-id="element-221">
          <div className="bg-gray-100 p-3 rounded-full mb-3" data-id="element-222">{icon}</div>
          <h4 className="font-medium mb-1" data-id="element-223">{title}</h4>
          <p className="text-sm text-gray-600 text-center mb-3" data-id="element-224">
            {description}
          </p>
          <button className="flex items-center text-sm bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-2 rounded-lg" data-id="element-225">
            <UploadIcon size={16} className="mr-2" data-id="element-226" />
            Choose File
          </button>
          <input type="file" className="hidden" ref={fileInputRef} onChange={handleFileSelect} accept="image/*,.pdf,.doc,.docx" data-id="element-227" />
        </div> : <div className="p-4" data-id="element-228">
          <div className="flex justify-between items-center mb-3" data-id="element-229">
            <h4 className="font-medium" data-id="element-230">{title}</h4>
            <button className="text-red-600 hover:bg-red-50 p-1 rounded-full" onClick={handleRemoveFile} data-id="element-231">
              <XIcon size={16} data-id="element-232" />
            </button>
          </div>
          {preview ? <div className="mb-3" data-id="element-233">
              <img src={preview} alt="Document preview" className="max-h-40 mx-auto rounded-lg border border-gray-200" data-id="element-234" />
            </div> : <div className="mb-3 bg-blue-50 rounded-lg p-4 flex items-center" data-id="element-235">
              <FileTextIcon size={24} className="text-blue-600 mr-3" data-id="element-236" />
              <div data-id="element-237">
                <p className="font-medium text-blue-800" data-id="element-238">{currentFile.name}</p>
                <p className="text-sm text-blue-600" data-id="element-239">
                  {formatFileSize(currentFile.size)}
                </p>
              </div>
            </div>}
          <button className="w-full text-sm bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-2 rounded-lg flex items-center justify-center" onClick={() => fileInputRef.current?.click()} data-id="element-240">
            <UploadIcon size={16} className="mr-2" data-id="element-241" />
            Replace File
          </button>
          <input type="file" className="hidden" ref={fileInputRef} onChange={handleFileSelect} accept="image/*,.pdf,.doc,.docx" data-id="element-242" />
        </div>}
    </div>;
};
export default DocumentUpload;